export enum SymbolState {
  PENDING = 0,
  NORMAL = 1,
  INNER_TEST = 2,
  OFFLINE = 3,
  INVISIBLE = 4,
  EXPLORE = 5,
}
